import React,{useEffect} from 'react'
import './App.css';
import { BrowserRouter,Routes,Route } from "react-router-dom";
import Login from './components/login/LoginComponent';
import Index from './components/index/IndexComponent';
import Registration from './components/registration/RegistrationComponent';
import Activate from './components/activate/ActivateComponent';
import Forgot from './components/forgot/ForgotComponent';
import Pay from './components/pay/PayComponent';
import RemoveUser from './components/removeUser/RemoveUserComponent';
import PayLoad from './components/payLoad/PayLoadComponent';
import Create from './components/create/CreateComponent';
import UserComponent from './components/user/UserComponent';
import ContactComponent from './components/contact/ContactComponent';
import UsersComponent from './components/users/UsersComponent';
import Sign from './components/sign/SignComponent';
import {Grid  } from '@material-ui/core';
import MenuIcon from '@mui/icons-material/Menu';
import {apiLogin} from './services/api/accounts/Login';
import { useTranslation } from "react-i18next";

const isAuthenticated = localStorage.getItem('token') != null && localStorage.getItem('token') != '';
const role = localStorage.getItem('role');
const email = localStorage.getItem('email');
const fullName = localStorage.getItem('fullName');
const avatar = localStorage.getItem('avatar') != null ? localStorage.getItem('avatar') : null;

const App = (props, match) => {
    const [open, setOpen] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [isMenu, setIsMenu] = React.useState(false);
    const [isBlur, setIsBlur] = React.useState(false);
    const [isRemoveUser, setIsRemoveUser] = React.useState(false);
    const [isNotification, setIsNotification] = React.useState(false);
    const [isOpenUser, setIsOpenUser] = React.useState(false);
    const [isOpenContacts, setIsOpenContacts] = React.useState(false);
    const [isOpenDocuments, setIsOpenDocuments] = React.useState(false);
    const [isOpenUsers, setIsOpenUsers] = React.useState(false);
    const [isOpenPayLoad, setIsOpenPayLoad] = React.useState(false);
    const [isOpenPay, setIsOpenPay] = React.useState(false);
    const [isHaveToPaid, setIsHaveToPaid] = React.useState(false);
    const { t, i18n, ready } = useTranslation();
    const anchorRef = React.useRef(null);

    useEffect(() => {
      async function fetchData() {
          await refreshItems();
          //var isHaveToPaid = await apiLogin.isHaveToPaid();
          
          //if(isAuthenticated && isHaveToPaid.daysToEnd)
          //{
            //setIsHaveToPaid(isHaveToPaid.daysToEnd);
            //setIsBlur(true);
            //setIsOpenPay(true);
          //}
          //window["loadWindow"]();
      }
      fetchData();

    }, []);

    const refreshItems = async ()=>{
      let data = await apiLogin.getNotificationUser();
      setItems(data.items);
    }

    const logOff = () =>{
      localStorage.setItem('token', '');
      localStorage.setItem('fullName', '');
      localStorage.setItem('role', '');
      localStorage.setItem('email', '');
      localStorage.setItem('avatar', '');
      window.location.href = "/";
    }

    const showUser = () =>{
      setIsMenu(false);
      setIsOpenUser(true);
    }

    const readNotification = async (id, documentId) =>{
      let data = await apiLogin.readNotifcation(id);
      window.location.href = "/sign?id="+documentId;
    }

    const showContacts = () =>{
      setIsMenu(false);
      setIsOpenContacts(true);
    }

    const showDocuments = () =>{
      setIsMenu(false);
      setIsOpenDocuments(true);
    }

    const showUsers = () =>{
      setIsMenu(false);
      setIsOpenUsers(true);
    }

    return (
      <div>
        <div className="top">
            {(email===null || email==='') && 
              <a href="/login" className='logo'></a>
            }
            {email!==null && email!=='' && 
              <div className={`main-wrapper`}>
                <Grid container>
                  <Grid item xs>
                    <a href="/index" className='left-logo'></a>
                  </Grid>
                  <Grid item style={{maxWidth: "300px", marginTop: "5px"}} className="right-element">
                    <a className='full-name'><i className='notification-icon' onClick={()=>{setIsNotification(!isNotification);setIsMenu(false);}} onMouseEnter={()=>{setIsNotification(true);setIsMenu(false);}}></i>&nbsp;&nbsp;&nbsp;&nbsp;<span onClick={()=>{setIsMenu(!isMenu);setIsNotification(false);}} onMouseEnter={()=>{setIsMenu(true);setIsNotification(false);}}>{fullName}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<MenuIcon /></span></a>
                    {isNotification && <ul className='menu' onMouseLeave={()=>setIsNotification(false)}>
                      {items.map((row, index) => {
                        return(<li key={index} className='notification'>
                            <Grid container>
                              <Grid item xs={12}>
                                <b>{row.createdDateName}</b>
                              </Grid>
                              <Grid item xs={12}>
                                {row.description.indexOf('został podpisany')>0 &&
                                  <h5>Nowy podpis</h5>
                                }
                                {row.description.indexOf('został podpisany')<=0 &&
                                  <h5>Podpisz dokument</h5>
                                }
                              </Grid>
                              <Grid item xs={12}>
                                <p onClick={()=>readNotification(row.id,row.documentId)}>{row.description}</p>
                              </Grid>
                            </Grid>
                          </li>)
                      })}
                    </ul>
                    }
                    {isMenu && <ul className='menu' onMouseLeave={()=>setIsMenu(false)}>
                      <li onClick={()=>showUser()}>{t("app_text1")}</li>
                      <li onClick={()=>showContacts()}>{t("app_text2")}</li>
                      {localStorage.getItem('role')==='2' && <li onClick={()=>showUsers()}>{t("app_text3")}</li>}
                      <li onClick={()=>{setIsBlur(true);document.getElementById('payload').style.display='';}}>{t("app_text2b")}</li>
                      <li href="https://signsafe.app/regulamin-serwisu-internetowego/">{t("app_text4")}</li>
                      <li href="https://signsafe.app/privacy-policy/">{t("app_text5")}</li>
                      <li><a onClick={()=>{setIsRemoveUser(true)}}>{t("app_text6b")}</a></li>
                      <li><a onClick={()=>{logOff()}}>{t("app_text6")}</a></li>
                    </ul>
                    }
                  </Grid>
                </Grid>
                <Grid container>
                    <UserComponent isOpenUser={isOpenUser} setIsOpenUser={setIsOpenUser}></UserComponent>
                </Grid>
                <Grid container>
                    <ContactComponent isOpenContacts={isOpenContacts} setIsOpenContacts={setIsOpenContacts}></ContactComponent>
                </Grid>
                <Grid container>
                    <UsersComponent isOpenUsers={isOpenUsers} setIsOpenUsers={setIsOpenUsers}></UsersComponent>
                </Grid>
                <Grid container>
                    <Pay isBlur={isBlur} setIsBlur={setIsBlur} isOpenPayLoad={isOpenPayLoad} setIsOpenPayLoad={setIsOpenPayLoad} isOpenPay={isOpenPay} isHaveToPaid={isHaveToPaid}  setIsOpenPay={setIsOpenPay}></Pay>
                </Grid>
                <Grid container>
                    <PayLoad isBlur={isBlur} setIsBlur={setIsBlur} isOpenPayLoad={isOpenPayLoad} setIsOpenPayLoad={setIsOpenPayLoad}></PayLoad>
                </Grid>
                <Grid container>
                    <RemoveUser isRemoveUser={isRemoveUser} setIsRemoveUser={setIsRemoveUser} logOff={logOff}></RemoveUser>
                </Grid>
              </div>
            }
        </div>
        <div className={`${isBlur ? "blur":''}`} id="all">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />}></Route>
              <Route path="sign" element={<Sign />} />
              <Route path="create" element={<Create />} />
              <Route path="login" element={<Login />} />
              <Route path="index" element={<Index />} />
              <Route path="registration" element={<Registration />} />
              <Route path="activate" element={<Activate />} />
              <Route path="forgot" element={<Forgot />} />
            </Routes>
          </BrowserRouter>
        </div>
      </div>
    );
}

export default App;